/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ offer: NonNullable<unknown> }} Signup_Offer_CtaInputs */

const en_signup_offer_cta = /** @type {(inputs: Signup_Offer_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get ${i?.offer}`)
};

const zh_hans1_signup_offer_cta = /** @type {(inputs: Signup_Offer_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`领取 ${i?.offer}`)
};

const pt_br2_signup_offer_cta = /** @type {(inputs: Signup_Offer_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ganhe ${i?.offer}`)
};

const es_signup_offer_cta = /** @type {(inputs: Signup_Offer_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtén ${i?.offer}`)
};

const fr_signup_offer_cta = /** @type {(inputs: Signup_Offer_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtenir ${i?.offer}`)
};

const de_signup_offer_cta = /** @type {(inputs: Signup_Offer_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.offer} sichern`)
};

const ru_signup_offer_cta = /** @type {(inputs: Signup_Offer_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Получить ${i?.offer}`)
};

const it_signup_offer_cta = /** @type {(inputs: Signup_Offer_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ottieni ${i?.offer}`)
};

/**
* | output |
* | --- |
* | "Get {offer}" |
*
* @param {Signup_Offer_CtaInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const signup_offer_cta = /** @type {((inputs: Signup_Offer_CtaInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Offer_CtaInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_signup_offer_cta(inputs)
	if (locale === "pt-BR") return pt_br2_signup_offer_cta(inputs)
	if (locale === "es") return es_signup_offer_cta(inputs)
	if (locale === "fr") return fr_signup_offer_cta(inputs)
	if (locale === "de") return de_signup_offer_cta(inputs)
	if (locale === "ru") return ru_signup_offer_cta(inputs)
	if (locale === "it") return it_signup_offer_cta(inputs)
	return en_signup_offer_cta(inputs)
});